// extracted by mini-css-extract-plugin
export default {"reactPlayer":"Template2_reactPlayer__-id0u","logo":"Template2_logo__Ibp7t","heading":"Template2_heading__EQQBB"};